import Today from './Today.jsx';
import { formatDate } from '../lib/format.js';

function yesterdayInET() {
  const now = new Date();
  const etToday = now.toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
  const [y, m, d] = etToday.split('-').map(Number);
  const etYesterday = new Date(Date.UTC(y, m - 1, d));
  etYesterday.setUTCDate(etYesterday.getUTCDate() - 1);
  return etYesterday.toISOString().slice(0, 10);
}

export default function Yesterday() {
  const iso = yesterdayInET();
  // No date in the kicker: the dateline under the masthead already spells it
  // out, and a raw 2026-09-19 right below it read as a debug string.
  return (
    <Today
      briefPath={`/api/get-brief?date=${iso}`}
      archiveLabel="Yesterday's brief"
      seoTitle={`Yesterday's Charleston Brief, ${formatDate(iso)} · Charleston.Vacations`}
    />
  );
}
